export default {
  app: {
    menuTop: {
      logout: "wyloguj"
    },
    validation: {
      email: `Adres email jest nieprawidłowy`,
      password: `Hasło musi zawierać minimum {minLength} znaków`,
      range: `Pole powinno zawierać od {from} do {to} znaków`,
      rangeTo: `Pole powinno zawierać maksymalnie {to} znaków`,
      rangeFrom: `Pole powinno zawierać minimum {from} znaków`,
      required: `Pole jest wymagane`
    }
  },
  files: {
    errors: {
      wrongMimeType: "wrongMimeType",
      fileTooLarge: "fileTooLarge"
    }
  },
  home: {
    title: "Dashboard | Fluct"
  },
  audits: {
    title: "Logi bezpieczeństwa"
  },
  pageTranslations: {
    forms: {
      createPageTranslation: {
        placeholder: {},
        errors: {}
      }
    }
  },
  fieldCategoryTranslation: {
    forms: {
      createFieldCategoryTranslation: {
        placeholder: {},
        errors: {}
      }
    }
  },
  pagesLists: {
    forms: {
      createPagesList: {
        placeholder: {},
        errors: {}
      }
    }
  },
  users: {
    title: "Użytkownicy",
    forms: {
      changePassword: {
        placeholder: {
          password: "",
          newPassword: "",
          newPasswordRepeat: ""
        },
        errors: {
          notTheSame: "Podane hasła się różnią",
          wrongData: "Niepoprawne dane",
          currentPasswordWrong: "Aktualne hasło niepoprawne"
        }
      },
      twoFactorAuth: {
        placeholder: {
          token: "wpisz token",
          currentPassword: "aktualne hasło"
        },
        errors: {
          notTheSame: "Podane hasła się różnią",
          wrongData: "Niepoprawne dane",
          currentPasswordWrong: "Aktualne hasło niepoprawne",
          tokenWrong: "Token niepoprawny"
        }
      },
      forgot: {
        button: {
          login: "Przypomnij hasło"
        },
        placeholder: {
          email: ""
        },
        errors: {
          wrongEmail: "Podanego emaila nie ma w bazie danych"
        }
      },
      setPassword: {
        button: {
          login: "Zatwierdź"
        },
        placeholder: {
          password: "",
          passwordConfirm: ""
        },
        errors: {
          wrongToken: "Twoje hasło zostało już ustawione",
          expiredToken: "Token wygasł. <br /> Zresetuj hasło ponownie.",
          notTheSame: "Hasła nie są takie same"
        }
      },
      createUser: {
        placeholder: {
          email: ""
        },
        errors: {
          emailTaken: "Podany email jest zajęty"
        }
      }
    }
  },
  auth: {
    forms: {
      login: {
        button: {
          login: "Zaloguj"
        },
        legend: "Logowanie",
        placeholder: {
          email: "",
          password: "",
          token: ""
        },
        errors: {
          passwordNotSet: "Użytkownik nie ma ustawionego hasła",
          userNotActive: "Użytkownik nie jest aktywowany",
          wrongEmail: "Email nieprawidłowy",
          wrongPassword: "Hasło nieprawidłowe",
          wrongPasswordOrEmail: "Email lub hasło nieprawidłowe",
          wrong2FAToken: "Token podwójnej autoryzacji nieprawidłowy"
        }
      }
    },
    index: {
      title: "AvantiMedic ERP"
    }
  },
  offers: {
    title: "Oferty pracy",
    forms: {
      createOffer: {
        placeholder: {
          city: "",
          when: "",
          patient: "",
          language: ""
        },
        errors: {
          wrongData: "Podane dane są niepoprawne",
          wrongMimeType: "Plik powinien być w formacie pdf",
          fileTooLarge: "Za duży plik",
          noFile: "Plik nie został wybrany"
        }
      }
    }
  },
  mediaCategories: {
    title: "Kategorie mediów",
    forms: {
      createCategory: {
        placeholder: {},
        errors: {
          wrongData: "Podane dane są niepoprawne",
          wrongMimeType: "Plik powinien być w formacie pdf",
          fileTooLarge: "Za duży plik",
          noFile: "Plik nie został wybrany"
        }
      }
    }
  },
  templates: {
    title: "Templatki",
    forms: {
      createCategory: {
        placeholder: {}
      }
    }
  },
  broker: {
    title: "Pośrednik",
    placeholder: {}
  },
  brokers: {
    title: "Pośrednicy"
  },
  smss: {
    title: "Smsy",
    placeholder: {}
  },
  alerts: {
    title: "Przypomnienia"
  },
  brokerAdd: {
    title: "Dodaj pośrednika",
    placeholder: {}
  },
  offer: {
    title: "Oferta",
    placeholder: {}
  },
  offerAdd: {
    title: "Dodaj ofertę",
    placeholder: {}
  },
  contractAdd: {
    title: "Dodaj umowę",
    placeholder: {}
  },
  contract: {
    title: "Przeglądaj umowę",
    placeholder: {}
  },
  notFound: {
    title: "Nie znaleziono strony"
  },
  logout: {
    title: "Jesteś wylogowany!"
  },
  forgot: {
    title: "Przypomnienie hasła"
  },
  setPassword: {
    title: "Ustaw nowe hasło"
  },
  profile: {
    title: "Profil użytkownika"
  },
  carers: {
    title: "Opiekunki"
  },
  carersAdd: {
    title: "Dodaj opiekunkę",
    placeholder: {
      birthDate: "dd.mm.yyyy"
    }
  },
  carer: {
    title: "Opiekunka",
    placeholder: {}
  },
  patients: {
    title: "Pacjenci",
    placeholder: {
      birthDate: "dd.mm.yyyy"
    }
  },
  patient: {
    title: "Pacjent",
    placeholder: {}
  },
  patientAdd: {
    title: "Dodaj pacjenta",
    placeholder: {}
  },
  invoices: {
    title: "Faktury"
  },
  invoice: {
    title: "Faktura"
  },
  invoicesAdd: {
    title: "Dodaj fakturę",
    placeholder: {}
  },
  addresses: {
    placeholder: {}
  },
  invoiceDatas: {
    placeholder: {}
  },
  reminders: {
    placeholder: {
      when: "dd.mm.yyyy"
    }
  },
  payments: {
    placeholder: {}
  },
  alerts: {
    placeholder: {}
  },
  contracts: {
    title: "Umowy"
  },
  lists: {
    billingType: [
      {
        label: "miesięczny",
        value: "monthly"
      }
    ],
    paymentCount: [
      {
        label: "odejmowana",
        value: "-1"
      },
      {
        label: "dodawana",
        value: "1"
      }
    ],
    paymentPlace: [
      {
        label: "biuro",
        value: "office"
      },
      {
        label: "pacjent",
        value: "patient"
      },
      {
        label: "pośrednik",
        value: "broker"
      }
    ],
    invoiceStatus: [
      {
        label: "opłacona",
        value: "opłacona"
      },
      {
        label: "do zapłaty",
        value: "do zapłaty"
      }
    ],
    paymentType: [
      {
        label: "gotówka",
        value: "gotówka"
      },
      {
        label: "przelew",
        value: "przelew"
      }
    ],
    contractStatus: [
      {
        label: "proponowana",
        value: "proponowana"
      },
      {
        label: "bus",
        value: "bus"
      },
      {
        label: "umowa",
        value: "umowa"
      },
      {
        label: "bus+umowa",
        value: "bus+umowa"
      },
      {
        label: "bus powrotny",
        value: "bus powrotny"
      },
      {
        label: "ustawiona",
        value: "ustawiona"
      },
      {
        label: "niemcy",
        value: "niemcy"
      },
      {
        label: "brak",
        value: "brak"
      }
    ],
    rateType: [
      {
        label: "dzienny",
        value: "daily"
      },
      {
        label: "miesięczny",
        value: "monthly"
      }
    ],
    contractType: [
      {
        label: "umowa zlecenie",
        value: "umowa zlecenie"
      },
      {
        label: "działalność gospodarcza",
        value: "działalność gospodarcza"
      },
      {
        label: "mini job",
        value: "mini job"
      },
      {
        label: "midi job",
        value: "midi job"
      }
    ],
    carerStatus: [
      {
        label: "wolna",
        value: "wolna"
      },
      {
        label: "w domu",
        value: "w domu"
      },
      {
        label: "nie wysyłać",
        value: "nie wysyłać"
      },
      {
        label: "nie odbiera",
        value: "nie odbiera"
      },
      {
        label: "nieaktualna",
        value: "nieaktualna"
      },
      {
        label: "zajęta",
        value: "zajęta"
      },
      {
        label: "niemcy",
        value: "niemcy"
      }
    ],
    boolean: [
      {
        label: "Tak",
        value: true
      },
      {
        label: "Nie",
        value: false
      }
    ],
    germanLevel: [
      {
        label: "1",
        value: "1"
      },
      {
        label: "2",
        value: "2"
      },
      {
        label: "3",
        value: "3"
      },
      {
        label: "4",
        value: "4"
      },
      {
        label: "5",
        value: "5"
      },
      {
        label: "6",
        value: "6"
      }
    ],
    remindersSortPopoverDate: [
      {
        label: "od najnowszych",
        value: "od najnowszych"
      },
      {
        label: "od najstarszych",
        value: "od najstarszych"
      }
    ],
    remindersSortPopoverCategory: [
      {
        label: "osoby",
        value: "osoby"
      },
      {
        label: "faktury",
        value: "faktury"
      },
      {
        label: "umowy",
        value: "umowy"
      }
    ]
  }
};



// WEBPACK FOOTER //
// ./src/common/intl/messages/pl.js